import { MutationTree } from 'vuex';
import { MessageTypesState } from './types';

export const mutations: MutationTree<MessageTypesState> = {
    setMessageTypes: (state, data) => {
        state.messageTypes = data;
    },
    setMessageTypeItem: (state, data) => {
        state.messageTypeItem = data;
    }
};